import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Sparkles, X } from "lucide-react";
import LiveCounter from "./LiveCounter";

export const AnnouncementBar = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (window.sessionStorage.getItem("equisight-announce-dismissed") === "1") {
      setVisible(false);
    }
  }, []);

  if (!visible) return null;

  const dismiss = () => {
    setVisible(false);
    if (typeof window !== "undefined") {
      window.sessionStorage.setItem("equisight-announce-dismissed", "1");
    }
  };

  return (
    <div
      data-testid="announcement-bar"
      className="relative z-[60] bg-[hsl(var(--ink))] text-[hsl(var(--background))]"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-6 py-2.5 lg:px-10">
        <a
          href="#waitlist"
          data-testid="announcement-cta"
          className="flex flex-1 flex-wrap items-center gap-x-3 gap-y-1 text-xs sm:text-sm"
        >
          <span className="inline-flex items-center gap-1.5 rounded-full bg-[hsl(var(--sand))] px-2.5 py-0.5 text-[10px] font-semibold uppercase tracking-[0.18em] text-[hsl(var(--ink))]">
            <Sparkles className="h-3 w-3" strokeWidth={1.8} />
            {t("announcement.betaTag")}
          </span>
          <span className="text-[hsl(var(--background))]/85">
            {t("announcement.live")}{" "}
            <span className="font-medium text-[hsl(var(--background))]">
              {t("announcement.liveDate")}
            </span>{" "}
            — {t("announcement.betaCta")}{" "}
            <span className="font-medium text-[hsl(var(--sand))]">
              {t("announcement.betaBonus")}
            </span>
            .
          </span>
          <span className="hidden text-[hsl(var(--sand))] sm:inline">→</span>
        </a>
        <div className="hidden shrink-0 md:block">
          <LiveCounter variant="dark" />
        </div>
        <button
          type="button"
          onClick={dismiss}
          aria-label={t("announcement.close")}
          data-testid="announcement-close"
          className="shrink-0 rounded-full p-1 text-[hsl(var(--background))]/60 transition-all hover:bg-white/10 hover:text-[hsl(var(--background))]"
        >
          <X className="h-4 w-4" strokeWidth={1.6} />
        </button>
      </div>
    </div>
  );
};

export default AnnouncementBar;
